import hgpNoResult from './main';

export default {
  install(Vue) {
    Vue.component(hgpNoResult.name, hgpNoResult);
  },
};

